import { useState } from 'react';
import { AppModal } from './AppModal';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { LoginForm } from './LoginForm';

export function LoginModal(props) {
    const [form, setForm] = useState("login");

    return (
      <AppModal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        onShow={() => { document.getElementsByTagName("body")[0].style = ""; }}
        onExited={() => { setForm("login"); }}
      >
        <AppModal.Header>
          <div>
            <span className="h-large">L</span><span className="h-small">ogin</span>
          </div>
        </AppModal.Header>
        <AppModal.Body>
          {form === "login"
            ? <LoginForm typeCallback={setForm} />
            : <ForgotPasswordForm typeCallback={setForm} />
          }
        </AppModal.Body>
      </AppModal>
    );
}
